import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../reports/ReportElementHelper";

class PropertyDeed extends Component {
  componentDidMount() {}

  render() {
    const node = this.props.deedNode;
    if (node === undefined) return null;
    const recs = [];
    getAllRows(node, recs, this.props, _.get(node, "$.display"));
    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.HeaderCell colSpan={2}>Deed Information</Table.HeaderCell>
          </Table.Row>
          {recs}
        </Table.Body>
      </Table>
    );
  }
}

export default PropertyDeed;



// WEBPACK FOOTER //
// ./src/components/searchresults/PropertyDeed.js